import { c as _c } from "react/compiler-runtime";
import React from 'react';
import PropTypes from 'prop-types';
import LabeledSelectBox from 'components/consumer/LabeledSelectBox';
import { states, additionalStates } from 'commons/usStates';
const getStatesList = includeAdditionalStates => {
  const allStates = includeAdditionalStates ? [...states, ...additionalStates] : states;
  if (includeAdditionalStates) {
    allStates.sort((a, b) => a.label.localeCompare(b.label));
  }
  return allStates.map(({
    label,
    abbreviation
  }) => ({
    label,
    value: abbreviation
  }));
};
const StateField = t0 => {
  const $ = _c(17);
  const {
    id: t1,
    name: t2,
    value,
    error,
    isTouched,
    handleBlur,
    setFieldValue,
    setFieldTouched,
    updateShipping,
    includeAdditionalStates: t3,
    isRequired: t4
  } = t0;
  const id = t1 === undefined ? "state" : t1;
  const name = t2 === undefined ? "state" : t2;
  const includeAdditionalStates = t3 === undefined ? false : t3;
  const isRequired = t4 === undefined ? true : t4;
  let t5;
  if ($[0] !== includeAdditionalStates) {
    t5 = getStatesList(includeAdditionalStates);
    $[0] = includeAdditionalStates;
    $[1] = t5;
  } else {
    t5 = $[1];
  }
  const usStatesList = t5;
  let t6;
  if ($[2] !== name || $[3] !== setFieldTouched || $[4] !== setFieldValue || $[5] !== updateShipping) {
    t6 = event => {
      setFieldValue(name, event.target.value);
      setFieldTouched(name);
      if (updateShipping) {
        updateShipping({
          state: event.target.value
        });
      }
    };
    $[2] = name;
    $[3] = setFieldTouched;
    $[4] = setFieldValue;
    $[5] = updateShipping;
    $[6] = t6;
  } else {
    t6 = $[6];
  }
  const t7 = isTouched && error ? error : null;
  const t8 = isRequired ? "" : undefined;
  const t9 = isRequired ? "" : undefined;
  let t10;
  if ($[7] !== handleBlur || $[8] !== id || $[9] !== name || $[10] !== t6 || $[11] !== t7 || $[12] !== t8 || $[13] !== t9 || $[14] !== usStatesList || $[15] !== value) {
    t10 = <LabeledSelectBox id={id} name={name} searchable={false} clearable={false} options={usStatesList} label="State *" onChange={t6} onBlur={handleBlur} value={value} autoComplete="address-level1" data-xc="shipping-state-field" errorMessage={t7} required={t8} aria-required={t9} fullHeight={true} />;
    $[7] = handleBlur;
    $[8] = id;
    $[9] = name;
    $[10] = t6;
    $[11] = t7;
    $[12] = t8;
    $[13] = t9;
    $[14] = usStatesList;
    $[15] = value;
    $[16] = t10;
  } else {
    t10 = $[16];
  }
  return t10;
};
StateField.propTypes = {
  error: PropTypes.string,
  handleBlur: PropTypes.func,
  id: PropTypes.string,
  isRequired: PropTypes.bool,
  isTouched: PropTypes.bool,
  name: PropTypes.string,
  setFieldTouched: PropTypes.func,
  setFieldValue: PropTypes.func,
  updateShipping: PropTypes.func,
  value: PropTypes.string,
  includeAdditionalStates: PropTypes.bool
};
export default StateField;